export enum tenantsCountriesEnum {
  lithuania = 'lithuania',
  estonia = 'estonia',
  latvia = 'latvia',
}
